import { Box, IconButton } from '@mui/material'
import { Dismiss16Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import { formatReplyCardTimestamp } from '@/utils/formatReplyCardTimestamp'
import styles from './index.module.scss'

/**
 * @param {{
 *   authorName: string,
 *   createdAt: number,
 *   snippet: string,
 *   onDismiss: () => void,
 * }} props
 */
export default function ComposerReplyPreview({ authorName, createdAt, snippet, onDismiss }) {
  const when = formatReplyCardTimestamp(createdAt)

  return (
    <Box className={styles.replyPreviewCard} role="status" aria-label="Replying to message">
      <Box className={styles.replyPreviewAccent} aria-hidden />
      <Box className={styles.replyPreviewMain}>
        <Box className={styles.replyPreviewHeader}>
          <Box className={styles.replyPreviewMeta}>
            <Box component="span" className={styles.replyPreviewName}>
              {authorName}
            </Box>
            {when ? (
              <Box component="span" className={styles.replyPreviewTime}>{` ${when}`}</Box>
            ) : null}
          </Box>
          <Tooltip text="Cancel reply" placement="top">
            <IconButton
              type="button"
              size="small"
              className={styles.replyPreviewDismiss}
              onClick={onDismiss}
              aria-label="Cancel reply"
            >
              <Dismiss16Regular className={styles.replyPreviewDismissIcon} aria-hidden />
            </IconButton>
          </Tooltip>
        </Box>
        <Box className={styles.replyPreviewSnippet} title={snippet || undefined}>
          {snippet || 'Message'}
        </Box>
      </Box>
    </Box>
  )
}
